"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProfileBasicController_js_1 = require("./ProfileBasicController.js");
exports.ProfileBasicController = ProfileBasicController_js_1.ProfileBasicController;
var ProfileAddressController_js_1 = require("./ProfileAddressController.js");
exports.ProfileAddressController = ProfileAddressController_js_1.ProfileAddressController;
var ProfileAccessController_js_1 = require("./ProfileAccessController.js");
exports.ProfileAccessController = ProfileAccessController_js_1.ProfileAccessController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/controllers/index.js
// module id = 433
// module chunks = 0